<template>
  <div class="app">
    <div class="ass"></div>
    <div class="header"></div>
    <div class="body">
      <div class="header_but">
        <h1 class="title">薪福荟选店铺入驻信息</h1>
      </div>
      <div class="main">
        <el-form ref="form" :model="form" class="form" label-position="left">
          <!--      审核进度-->
          <div class="schedule" v-show="schedule_active">
            <p class="shop_information">审核进度</p>
            <div class="top_img">
              <el-image
                style="width: 70px; height: 70px"
                :src="require(`../assets/state/${state_image}.png`)"
                fit="fill"></el-image>
              <div>
                <strong style="font-size: 18px">{{ schedule_active === 2 ? '审核中' : schedule_active === 3 ? '审核通过' : '审核拒绝' }}</strong>
              </div>
            </div>
            <el-steps :active="schedule_active" align-center>
              <el-step icon="el-icon-success" title="入驻申请" :description="getTime(createTime)"></el-step>
              <el-step icon="el-icon-success" title="审核中"></el-step>
              <el-step icon="el-icon-success" title="审核结果" :description="getTime(auditTime)"></el-step>
            </el-steps>
            <div class="account" v-show="jujue_shuoming !== ''">
              <strong class="label">审核说明：</strong><span class="text">{{jujue_shuoming}}</span>
            </div>
          </div>
          <div class="body_one">
            <p class="shop_information">店铺基本信息</p>
            <div class="but">
              <el-form-item label="店铺LOGO" class="shop_logo">
                <el-upload
                  action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
                  :limit="1"
                  :class="[form.dialogImageUrl === '' ? 'uploadLogo' : 'uploadLogo2']"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadseccess"
                  list-type="picture-card"
                  accept=".png,.jpg,.jpeg,.gif"
                  :file-list="form.logoImg"
                  :on-remove="handleRemove"
                  >
                  <img class="logo_img" src="../assets/shop_group.png">
                </el-upload>
              </el-form-item>
              <div class="prompt_text">建议尺寸200*200像素</div>
            </div>
            <div class="but">
              <el-form-item label="店铺名称" class="shop_name">
                <el-input v-model="form.shop_name" maxlength="20" placeholder="请输入店铺名称" class="shop"
                          clearable></el-input>
              </el-form-item>
              <div class="prompt_text">店铺名称建议20字符以内，超出可能在店铺页展示不全</div>
            </div>
            <div class="but">
              <el-form-item label="店铺简介" class="shop_introduction">
                <el-input
                  type="textarea"
                  placeholder="请输入店铺简介"
                  v-model="form.shop_textarea"
                  maxlength="100"
                  show-word-limit
                  :autosize="{ minRows: 1, maxRows: 4}"
                  class="shop_textarea"
                  clearable
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="店铺所在地区" class="shop_address">
                <div class="box_ss">
                  <van-field
                    v-model="form.shop_value"
                    is-link
                    readonly
                    label=""
                    placeholder="请选择所在地区"
                    @click="show = true"
                  />
                  <van-popup v-model="show" round position="bottom" class="van_popup">
                    <van-area class="van_area" title="店铺所在地区" :area-list="options" @confirm="vanArea"
                              @cancel="vanCancel"/>
                  </van-popup>
                </div>
              </el-form-item>
            </div>
            <div class="but but_bottom">
              <el-form-item label="店铺备注" class="shop_remarks">
                <el-input
                  type="textarea"
                  placeholder="请输入备注"
                  v-model="form.shop_remarks"
                  maxlength="100"
                  show-word-limit
                  :autosize="{ minRows: 1, maxRows: 4}"
                  class="shop_textarea"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="body_three">
            <p class="shop_information">店铺联系信息</p>
            <div class="but but_bottom">
              <el-form-item label="店铺管理员昵称" class="shop_contact_address">
                <el-input v-model="form.posAdmin" maxlength="10" placeholder="请输入店铺管理员昵称"
                          class="contact_phone" clearable></el-input>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="店铺联系电话" class="shop_phone">
                <el-input v-model="form.shop_phone" maxlength="11" :disabled="true" placeholder="请输入店铺联系电话" class="contact_phone"
                          clearable></el-input>
              </el-form-item>
              <div class="prompt_text">联系电话会作为审核成功短信通知、账号登录的依据。</div>
            </div>
            <div class="but but_bottom">
              <el-form-item label="店铺联系地址" class="shop_contact_address">
                <el-input v-model="form.shop_contact_address" maxlength="20" placeholder="请输入店铺联系地址"
                          class="contact_phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="body_four">
            <p class="shop_information">店铺证照信息</p>
            <div class="but">
              <el-form-item label="上传执照照片" class="shop_logo"">
                <el-upload
                  action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadBusLicenseImg"
                  :limit="1"
                  :class="[form.dialogImageUrl2 === '' ? 'uploadLogo' : 'uploadLogo2']"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadseccess2"
                  list-type="picture-card"
                  accept=".png,.jpg,.jpeg,.gif"
                  :file-list="form.logoImg2"
                  :on-remove="handleRemove2">
                  <img class="logo_img" src="../assets/shop_group.png"  alt=""/>
                </el-upload>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="其他资质图片" class="shop_license">
                <el-upload
                  action="https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/fileUpload/uploadImg"
                  :limit="1"
                  :class="[form.dialogImageUrl3 === '' ? 'uploadLogo' : 'uploadLogo2']"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadseccess3"
                  list-type="picture-card"
                  accept=".png,.jpg,.jpeg,.gif"
                  :file-list="form.logoImg3"
                  :on-remove="handleRemove3">
                  <img class="logo_img" src="../assets/shop_group.png"  alt=""/>
                </el-upload>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="企业名称:" class="shop_contact_address">
                <el-select
                ref="selectAll"
                  v-model="form.enterprise_name"
                  filterable  
                  remote  
                  reserve-keyword  
                  placeholder="请输入企业名称"
                  @blur="selectBlur"
                  @focus="selectFocus"
                  @change="selectQiye"
                  @hook:mounted="cancalReadOnly"
                  @visible-change="cancalReadOnly"
                  :remote-method="remoteMethod"  
                  :loading="loading">
                  <el-option  
                    v-for="item in qiyeOptions"  
                    :key="item.value"  
                    :label="item.label"  
                    :value="item.value">  
                  </el-option>  
                </el-select> 
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="企业类型:" class="shop_contact_address">
                <el-input v-model="form.type_of_enterprise" placeholder="请输入企业类型" maxlength="20" show-word-limit clearable/>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="信用代码:" class="shop_contact_address">
                <el-input v-model="form.credit_code" placeholder="请输入统一社会信用代码" clearable/>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="注册省份:" class="shop_contact_address">
                <el-select v-model="form.domicile" placeholder="请选择注册省份">
                  <el-option
                    v-for="item in options_as"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="执照法人:" class="shop_contact_address">
                <el-input v-model="form.licensed_legal_person" placeholder="请输入执照法人" maxlength="20" show-word-limit
                  clearable/>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="注册资金:" class="shop_contact_address">
                <el-input v-model="form.registered_capital" placeholder="请输入注册资金" maxlength="20" show-word-limit clearable/>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="注册时间:" class="shop_contact_address">
                <el-date-picker
                  prop="issueTime"
                  v-model="form.issueTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择注册时间">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="证照期限:" class="shop_contact_address">
                <el-input v-model="form.term_of_operation" placeholder="请输入证照期限" maxlength="30" show-word-limit clearable/>
              </el-form-item>
            </div>
            <div class="but">
              <el-form-item label="经营范围:" class="shop_contact_address">
                <el-input v-model="form.business_scope" type="textarea" :rows="3" placeholder="请输入营业范围" maxlength="100"
                  show-word-limit clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="bottom" v-if="schedule_active !== 3">
          <el-button class="bottom_button" @click="onSubmit">{{floot_bottom}}</el-button>
        </div>
      </div>
      <!--      底部 提交 按钮-->
      <!--        <div class="bottom">-->
      <!--          <el-button class="bottom_button" @click="onSubmit">提  交</el-button>-->
      <!--        </div>-->
      <el-dialog
        :visible.sync="dialogVisible"
        width="70%"
        style="margin-top: 10vh"
        customClass="messageZindex"
        :modal-append-to-body='false'
        :show-close="false"
        class="dialog_dialogVisible"
        :before-close="handleClose">
        <p><img src="../assets/Vector.png" alt="" style="width: 50px; height: 50px;"></p>
        <h2 class="submit_success">{{success}}</h2>
        <h4 class="">管理员审核通过会以短信通知您</h4>
        <span slot="footer" class="dialog-footer" @click="handleClose">
            返回
          </span>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogVisible_bos"
        width="85%"
        class="shenhe"
        :modal-append-to-body="false"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center>
        <el-form
          ref="ruleForm"
          :rules="ruleF"
          :model="ruleForm"
          class="login-form"
          autocomplete="on"
          label-position="left">
          <div class="img_but">
            <img src="../assets/logo10@2x.jpg" class="logo_img" alt="" />
          </div>
          <div class="title_but">薪福荟选店铺入驻信息</div>
          <el-form-item class="item_phone">
            <el-input v-model="ruleForm.phone" type="text" oninput="value=value.replace(/[^\d.]/g,'')" @input="checkPhone" placeholder="输入手机号" maxlength="11" class="phone" />
            <i v-show="!ruleForm_phone" class="iconfont icon-xiayibu"></i>
            <i v-show="ruleForm_phone && !icon_loading && !phone_state" class="iconfont icon-xiayibu" @click="phone_search" style="color: #494949"></i>
            <i v-show="ruleForm_phone && icon_loading" class="ips el-icon-loading"></i>
          </el-form-item>

          <el-form-item prop="yanzhengma" class="item_yanzhengma" v-show="phone_state">
            <el-input v-model="ruleForm.yanzhengma" type="text" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="输入验证码" maxlength="6" class="yanzhengma">
              <el-button v-show="countshow" slot="append" type="primary" class="button button1"
                         @click="submityan('ruleForm')">发送验证码
              </el-button>
              <el-button v-show="!countshow" slot="append" type="primary" class="button button2" disabled>{{ count }} s</el-button>
            </el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer" v-show="phone_state">
          <el-button style="background-color: #2082dd;border: #2082dd;" size="medium" type="primary" @click="submitForm">下一步</el-button>
          <!--          <el-button size="medium" type="danger" @click="submitForm">删除</el-button>-->
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { regionData, TextToCode, CodeToText } from "element-china-area-data";
import axios from "axios";
import {Cascader, Popup, Field, Area} from "vant";
import {areaList} from '../area.js'
import {getDate, isvalidPhone} from "../utils";

export default {
  name: "H5",
  components: {
    vanCascader: Cascader,
    vanPopup: Popup,
    vanField: Field,
    vanArea: Area,
  },
  data() {
    return {
      headers: {
            'Content-type': 'multipart/form-data'
      },
      shop_phone_label: false,
      posid: '',
      certificateid: '',
      floot_bottom: '提交',
      success: '提交成功',
      state_image: 'zhong', // 审核状态的图片 {zhong,wan,ju}
      jujue_shuoming: '', // 审核拒绝的说明
      createTime: '', // 创建时间
      auditTime: '', // 审核时间
      schedule_active: 0, // 审核进度
      phone_state: false,
      codeId: '',
      // dialogVisible_bos: true,
      dialogVisible_bos: false,
      show: false,
      fieldValue: "",
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      options: areaList,
      dialogVisible: false, // 提交的弹窗
      form: {
        dialogImageUrl: '', // logo
        logoImg: [], // 店铺logo
        shop_name: '', // 店铺名称
        shop_textarea: '', // 店铺简介
        shop_value: '', // 地区数据
        shop_remarks: '', // 店铺备注
        posAdmin: '', // 店铺管理员昵称
        shop_phone: '', // 店铺联系电话
        shop_contact_address: '', // 店铺联系地址
        dialogImageUrl2: '', // 执照照片
        logoImg2: [], // 执照照片
        dialogImageUrl3: '', // 其他资质照片
        logoImg3: [], // 其他资质照片
        enterprise_name: '', // 企业名称
        type_of_enterprise: '', // 企业类型
        credit_code: '', // 信用代码
        licensed_legal_person: '', // 执照法人
        domicile: '', // 注册地
        registered_capital: '', // 注册资金
        issueTime:'', // 注册时间
        term_of_operation: '', // 证照期限
        business_scope: '' // 经营范围
      },
      qiyeOptions:[], // 企业集合
      searchQuery: '', // 用户输入的搜索词   
      loading: false, // 是否正在加载的标识  
      searchTimeout: null, // 用于存储 setTimeout 的 ID
      ruleForm_phone: false,
      icon_loading: false,
      options_as: regionData, // 地区
      selectedOptions: [], // 地区
      countshow: true,
      count: '',
      ruleForm: {
        // phone: '19832592616',
        phone: '',
        yanzhengma: ''
      },
      ruleF: {
        phone: [
          {required: true, message: "请输入联系方式", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            // pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            //pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
          },
        ]
      },
    }
  },
  // created(){
  //   this.getPosDetailVOByPhone(this.ruleForm.phone)
  // },
  computed: {
    getTime() {
      return function(time) {
        return getDate(time)
      }
    }
  },
  methods: {
    checkPhone(value) {
      this.ruleForm_phone = !!isvalidPhone(value);
      this.phone_state = false
    },
    phone_search() { // 查询手机号是否存在
      this.icon_loading = true
      this.schedule_active = 0
      if (this.ruleForm.phone !== '') {
        const url = "pos/checkPhoneIsExist?phone=" + this.ruleForm.phone
        axios.get(url).then(res => {
          setTimeout(() => {
            this.icon_loading = false
            if (res.data.code === 200) {
              const rps = res.data.extend.data
              if (rps === false) {
                this.phone_state = true
                this.submityan('ruleForm')
              } else {
                this.getPosDetailVOByPhone(this.ruleForm.phone)
                this.shop_phone = true
                this.dialogVisible_bos = false
                this.form.shop_phone = this.ruleForm.phone
              }
            } else if (res.data.code === 100) {
              this.$message.error(res.data.extend.data)
            } else {
              this.$message.error('请检查手机号格式是否正确')
            }
          }, 1500)

        })
      } else {
        this.$message.error('手机号不可为空!')
      }
    },
    // 根据手机号查询数据
    getPosDetailVOByPhone(phone) {
      const that = this
      const url = 'pos/getPosDetailVOByPhone?phone=' + phone
      axios.get(url).then(res => {
        if (res.data.code === 200) {
          const data = res.data.extend.data

          const dats = data.posAddress.split(',')
          let loc = ''
          let options = []
          if (!parseInt(dats[0])) {
            loc = data.posAddress
            dats[0] === dats[1] ? dats[1] = '市辖区' : dats[1]
            if (dats.length > 1) {
              if (TextToCode[dats[0]].code) {
                options = ([TextToCode[dats[0]].code, TextToCode[dats[0]][dats[1]].code, TextToCode[dats[0]][dats[1]][dats[2]].code])
              } else {
                options = ([CodeToText[dats[0]], CodeToText[dats[0]][dats[1]], CodeToText[dats[0]][dats[1]][dats[2]]])
              }
            } else {
              options = []
            }
          } else {
            const address = data.posAddress.split(',')
            options = address
            address.forEach(item => {
              loc += CodeToText[item] + ','
            })
          }

          let img1 = ''
          let img2 = ''
          data.imgTypeList.map(item => {
            if (item.imgType === 0) {
              img1 = item.imgUrl
            } else if (item.imgType === 1) {
              img2 = item.imgUrl
            } else {
              console.log('图片赋值失败')
            }
          })
          that.form = {
            dialogImageUrl: data.posImg, // logo
              shop_name: data.posName, // 店铺名称
              shop_textarea: data.posDesc, // 店铺简介
              shop_value: loc, // 地区数据
              region: options,
              shop_remarks: data.remakeName, // 店铺备注

              posAdmin: data.posAdmin, // 店铺管理员昵称
              shop_phone: data.telPhone, // 店铺联系电话
              shop_contact_address: data.contactAddress, // 店铺联系地址
              dialogImageUrl2: img1, // 执照照片
              dialogImageUrl3: img2, // 其他资质照片
              logoImg: [], // 店铺logo
              logoImg2: [], // 执照照片
              logoImg3: [], // 其他资质照片
              enterprise_name: data.companyName, // 企业名称
              type_of_enterprise: data.companyType, // 企业类型
              credit_code: data.creditCode, // 信用代码
              licensed_legal_person: data.faRen, // 执照法人
              registered_capital: data.regMoney, // 注册资本
              issueTime: data.issueTime, // 注册时间
              term_of_operation: data.certificateIndate, // 营业期限
              business_scope: data.certificateRange, // 经营范围
              domicile: data.address // 注册地
          }
          that.form.logoImg.push({url: data.posImg})
          that.form.logoImg2.push({url: img1})
          if(img2){
            that.form.logoImg3.push({url: img2})
          }
          that.floot_bottom = '更新'

          that.posid = data.posId
          that.dialogVisible_bos = false
        }
      })
    },
    submitForm() { // 查询店铺
      const that = this
      if (that.ruleForm.yanzhengma !== '') {
        const url = 'pos/getPosEntityByPhone'
        const data = {
          code: that.ruleForm.yanzhengma,
          phone: that.ruleForm.phone
        }
        axios.post(url, data).then(res => {
          if (res.data.code === 200) {
            this.shop_phone = true
            this.dialogVisible_bos = false
            this.form.shop_phone = this.ruleForm.phone

            const data = res.data.extend.data
            that.schedule_active = data.auditState += 2 // 2 审核中 3 审核成功 4 审核拒绝
            that.state_image = that.schedule_active === 2 ? 'zhong' : that.schedule_active === 3 ? 'wan' : 'ju'
            that.jujue_shuoming = data.auditRemark ? data.auditRemark : '' // 审核说明
            that.createTime = data.createTime ? data.createTime : ''
            that.auditTime = data.auditTime ? data.auditTime : ''

            const pos = data.posEntity.pos
            const posCertificate = data.posEntity.posCertificate
            const dats = pos.posaddress.split(',')
            let options = []
            let loc = ''
            if (!parseInt(dats[0])) {
              loc = pos.posaddress
              dats[0] === dats[1] ? dats[1] = '市辖区' : dats[1]
              if (dats.length > 1) {
                if (TextToCode[dats[0]].code) {
                  options = ([TextToCode[dats[0]].code, TextToCode[dats[0]][dats[1]].code, TextToCode[dats[0]][dats[1]][dats[2]].code])
                } else {
                  options = ([CodeToText[dats[0]], CodeToText[dats[0]][dats[1]], CodeToText[dats[0]][dats[1]][dats[2]]])
                }
              } else {
                options = []
              }
            } else {
              const address = pos.posaddress.split(',')
              options = address
              address.forEach(item => {
                loc += CodeToText[item] + ','
              })
            }
            that.form = {
              dialogImageUrl: pos.posimg,
              shop_name: pos.posname,
              shop_textarea: pos.posdesc,
              options: options, // loc
              shop_value: loc, // options

              shop_remarks: pos.remakename,
              purchase: pos.takeincolonel,
              shop_remarks_profit: pos.colonelscale,
              shop_remarks_no_profit: pos.colonelbscale,
              logoImg2: pos.kefuurl, // 执照
              shop_phone: pos.telphone,
              shop_contact_address: posCertificate.contactAddress,
              shop_contact_name: posCertificate.companyName,
              shop_contact_type: posCertificate.title,
              shop_contact_credit: posCertificate.registrationNumber,
              shop_contact_license: posCertificate.posAdmin,
              shop_contact_domicile: posCertificate.address,
              shop_contact_register: posCertificate.registeredFund,
              shop_contact_business: posCertificate.certificateIndate,
              shop_contact_range: posCertificate.certificateRange
            }
            that.form.logoImg = []
            that.form.logoImg.push({url: pos.posimg})
            that.form.logoImg2 = []
            that.form.logoImg2.push({url: pos.kefuurl})
            that.floot_bottom = '更新'
            that.posid = pos.posid
            that.certificateid = posCertificate.certificateid
            that.dialogVisible_bos = false
          } else {
            // this.$message.error('您的手机号已有登录权限，暂不支持入驻店铺，可更换其他手机号申请入驻!')
            this.$message.error(res.data.extend.data)
          }
        })
      } else {
        that.$message.error('验证码不可为空!')
      }
    },
    // 发送验证码
    submityan(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countshow = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.countshow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          const url1 = 'login/sendSms?phone=' + this.ruleForm.phone
          axios.get(url1).then(res => {
            if (res.data.code === 200) {
              this.codeId = res.data.extend.phoneCodeId
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // area 点击确定事件
    vanArea(e) {
      const that = this
      that.show = false
      let a = ''
      for (let i = 0; i < e.length; i++) {
        a = a + (i === 0 ? '' : ',') + e[i].name
      }
      // that.fieldValue = a
      that.form.shop_value = a
    },
    // area 取消事件
    vanCancel() {
      const that = this
      that.show = false
      that.form.shop_value = ''
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({selectedOptions}) {
      // 没有 children 时触发
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    beforeAvatarUpload(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      console.log(file.type,isJPG)
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式或者 PNG 格式')
      }
      return isJPG
    },
    // 店铺logo图片上传事件
    uploadseccess(response, file, fileList) {
      if (this.form.dialogImageUrl === '') {
        this.file = file.raw
        const formData = new FormData()
        formData.append('file', this.file)
        axios.post('fileUpload/uploadImg', formData, {
          headers: {
            'Content-type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.data.code === 200) {
            this.form.dialogImageUrl = response.data.extend.resultMap.url // 店铺logo
            this.form.logoImg.push(response.data.extend.resultMap) // 店铺logo
          }
        }).catch((response) => {
          console.log('错误' + response)
        })
      } else {
        console.log('123')
      }
    },
    // 删除店铺logo图片事件
    handleRemove() {
      this.form.dialogImageUrl = ''
      this.form.logoImg = []
    },
    // 执照图片上传事件
    uploadseccess2(response, file, fileList) {
      if (this.form.dialogImageUrl2 === '') {
        this.file = file.raw
        const formData = new FormData()
        formData.append('file', this.file)
        axios.post('fileUpload/uploadImg', formData, {
          headers: {
            'Content-type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.data.code === 200) {
            this.form.dialogImageUrl2 = response.data.extend.resultMap.url // 执照图片
            this.form.logoImg2.push(response.data.extend.resultMap) // 执照图片
          }
        }).catch((response) => {
          console.log('错误' + response)
        })
      } else {
        console.log('123')
      }
    },
    // 删除执照图片事件
    handleRemove2() {
      this.form.dialogImageUrl2 = ''
      this.form.logoImg2 = []
    },
    // 提交其他资质图片事件
    uploadseccess3(response, file, fileList) {
      if (this.form.dialogImageUrl3 === '') {
        this.file = file.raw
        const formData = new FormData()
        formData.append('file', this.file)
        axios.post('fileUpload/uploadImg', formData, {
          headers: {
            'Content-type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.data.code === 200) {
            this.form.dialogImageUrl3 = response.data.extend.resultMap.url // 执照图片
            this.form.logoImg3.push(response.data.extend.resultMap) // 执照图片
          }
        }).catch((response) => {
          console.log('错误' + response)
        })
      } else {
        console.log('123')
      }
    },
    // 删除其他资质图片事件
    handleRemove3() {
      this.form.dialogImageUrl3 = ''
      this.form.logoImg3 = []
    },
    // 让选择框失焦时input不会被清空
    selectBlur(e){
      this.form.enterprise_name = e.target.value
      this.$forceUpdate()
      // 这个setTimeout和下面cancalReadOnly方法用来解决苹果系列获取焦点但是键盘没有唤起的问题
      // https://blog.csdn.net/Min_nna/article/details/125180495
      setTimeout(() => {
        if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){ //判断iPhone|iPad|iPod|iOS
          this.$refs.selectAll.blur()
        }
        var scrollHeight=document.documentElement.scrollTop || document.body.scrollTop||0
        window.scrollTo(0,Math.max(scrollHeight-1,0))
      }, 100)
    },
    //取消只读
    cancalReadOnly(onOff){
      this.$nextTick(()=>{
        if(!onOff){
          const {selectAll} =this.$refs
          const input =selectAll.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
        }
      })
    },
    selectFocus(e){
      // console.log(this.$refs.selectAll.$el.querySelector('input'))
      this.$refs.selectAll.$el.querySelector('input').focus()
    },
    selectQiye(item){
      this.qiyeOptions.forEach(item2 => {
        if(item === item2.companyName){
          this.form.type_of_enterprise = item2.companyType
          this.form.credit_code = item2.creditCode
          this.form.licensed_legal_person = item2.faRen
          this.form.registered_capital = item2.regMoney
          this.form.issueTime = item2.issueTime
        }
      })
    },
    async remoteMethod(query) { 
      if (query !== '') {
          this.loading = true;
          // 清除之前的定时器  
          if (this.searchTimeout) {  
            clearTimeout(this.searchTimeout);  
          }  
          // 设置新的定时器  
          this.searchTimeout = setTimeout(async () => {
            this.loading = false
            // 调用远程搜索方法  
            const { data } = await axios.get('/pos/getCompany?keyword=' + `'${query}'`)
            this.qiyeOptions = data.extend.data.map(item => {
              return {value:item.companyName, lable:item.creditCode, ...item}
            })
            // console.log(this.qiyeOptions);
          }, 1200)
        } else {
          this.options = [];
      }
    }, 
    // 监听 团购商品利润 输入框
    checkNumber() {
      // 只允许输入数字
      this.form.shop_remarks_profit = this.form.shop_remarks_profit.replace(/[^\d]/g, '')
      // 最小值为1
      if (this.form.shop_remarks_profit < 1) {
        this.form.shop_remarks_profit = 1
      } else if (this.form.shop_remarks_profit > 99) {
        this.form.shop_remarks_profit = 99
      } else {
        console.log('错误:' + this.form.shop_remarks_profit)
      }
    },
    // 监听 非团购商品利润 输入框
    checkNumberB() {
      // 只允许输入数字
      this.form.shop_remarks_no_profit = this.form.shop_remarks_no_profit.replace(/[^\d]/g, '')
      // 最小值为1
      if (this.form.shop_remarks_no_profit < 1) {
        this.form.shop_remarks_no_profit = 1
      } else if (this.form.shop_remarks_no_profit > 99) {
        this.form.shop_remarks_no_profit = 99
      } else {
        console.log('错误:' + this.form.shop_remarks_no_profit)
      }
    },
    // 根据省市区选择器得到最终的地址信息
    handleChange() {
      let loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += codeToText[this.selectedOptions[i]] + ','
      }
      this.form.shop_value = loc.slice(0, loc.length - 1)
    },
    // 关闭弹窗
    handleClose() {
      const that = this
      const active = that.form
      active.dialogImageUrl = '' // logo
      active.logoImg = [] // 店铺logo
      active.shop_name = '' // 店铺名称
      active.shop_textarea = '' // 店铺简介
      active.shop_value = '' // 地区数据
      active.shop_remarks = '' // 店铺备注
      active.purchase = false // 是否开启团购功能
      active.shop_remarks_profit = '25' // 团购商品利润
      active.shop_remarks_no_profit = '15' // 非团购商品利润
      active.shop_phone = '' // 店铺联系电话
      active.shop_contact_address = '' // 店铺联系地址
      active.dialogImageUrl2 = '' // 执照照片
      active.logoImg2 = [] // 执照照片
      active.shop_contact_name = '' // 企业名称
      active.shop_contact_type = '' // 企业类型
      active.shop_contact_credit = '' // 信用代码
      active.shop_contact_license = '' // 执照法人
      active.shop_contact_domicile = '' // 住所
      active.shop_contact_register = '' // 注册资本
      active.shop_contact_business = '' // 营业期限
      active.shop_contact_range = '' // 经营范围
      that.show = false
      that.selectedOptions = [] // 选择的店铺所在地区的数据
      that.schedule_active = 0
      that.ruleForm = {
        phone: '',
        yanzhengma: ''
      }
      that.count = ''

      that.shop_phone_label = false
      that.dialogVisible = false
      // 提交成功后用于刷新当前页面
      that.$router.go(0)
    },
    // 提交事件
    onSubmit() {
      const that = this
      const active = that.form
      if (active.dialogImageUrl === '' ||
        active.shop_name === '' ||
        active.shop_textarea === '' ||
        active.shop_value === '' ||
        active.posAdmin === '' ||
        active.shop_phone === '' ||
        active.shop_contact_address === '' ||
        active.enterprise_name === '' ||
        active.type_of_enterprise === '' ||
        active.credit_code === '' ||
        active.licensed_legal_person === '' ||
        active.domicile === '' ||
        active.registered_capital === '' ||
        active.issueTime === ''  ||
        active.term_of_operation === '' ||
        active.business_scope === '' ) {
        that.$message({
          message: '必填项不可为空',
          type: 'error'
        })
      } else {
        // const url = this.floot_bottom === '提交' ? '/back/pos/addPos' : '/back/pos/updatePos'
        const url = 'pos/addNewPos'
        const PosAddDto = {
          posImg: active.dialogImageUrl, // logo
          posName: active.shop_name, //店铺名称
          posDesc: active.shop_textarea, // 简介
          posAddress: active.shop_value, // 所在地区
          remakeName: active.shop_remarks, // 备注

          posAdmin: active.posAdmin, // 店铺管理员昵称
          telPhone: active.shop_phone, // 店铺联系电话
          contactAddress: active.shop_contact_address, // 店铺联系地址
          imgTypeList: [], // 执照照片 / 其他资质照片
        }
        const posCertificate = {
            contactAddress: active.shop_contact_address, // 店铺联系地址
            companyName: active.enterprise_name, // 企业名称
            companyType: active.type_of_enterprise, // 企业类型
            creditCode: active.credit_code, // 信用代码
            faRen: active.licensed_legal_person, // 执照法人
            regMoney: active.registered_capital, // 注册资本
            issueTime: active.issueTime, // 注册时间
            certificateIndate: active.term_of_operation, // 营业期限
            certificateRange: active.business_scope, // 经营范围
            provinceId: active.domicile // 注册地
        }
        if (this.floot_bottom === '更新') {
          PosAddDto.posId = this.posid
          that.success = '更新成功'
        }
        if (this.form.dialogImageUrl2 !== '') {
          PosAddDto.imgTypeList.push({imgUrl: this.form.dialogImageUrl2, imgType: 0})
        }
        if (this.form.dialogImageUrl3 !== '') {
          PosAddDto.imgTypeList.push({imgUrl: this.form.dialogImageUrl3, imgType: 1})
        }
        axios.post(url, {...PosAddDto,...posCertificate}).then(res => {
          if (res.data.code === 200) {
            this.$message.success('店铺入驻信息已提交，请等待审核')
            that.dialogVisible = true
            // 提交成功后用于刷新当前页面
            // this.$router.go(0)
            setTimeout(() => {
              this.dialogVisible_bos = true
            },2000)
          }else if (res.data.code === 100 || res.data.extend.data.code !== 0) {
            // that.$message.error(res.data.extend.data.code === 2 ? '添加失败，当前商户审核失败' : '添加失败，手机号已被注册')
            that.$message.error(res.data.extend.data)
          }else {
            that.$message.error('操作失败')
          }
        }).catch(error => {
          console.log(error);
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
li {
  list-style: none;
}

.messageZindex {
  z-index: 9999 !important;
}

.app {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #f1f1f1;
  //头部
  .header {
    width: 100vw;
    position: fixed;
    z-index: 1;
    height: 20vh;
    background-color: #2082dd;
    border-bottom-left-radius: 18%;
    border-bottom-right-radius: 18%;
  }

  .body {
    position: relative;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    //头部
    .header_but {
      position: fixed;
      z-index: 15;
      background-color: #2082dd;
      //position: fixed;
      width: 100vw;
      height: 8vh;

      .title {
        margin: 0;
        height: 8vh;
        line-height: 8vh;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }
    }

    //主体
    .main {
      position: absolute;
      width: calc(100vw - 6vw);
      //height: calc(100vh - 16vh);
      height: calc(100vh - 8vh - 5px);
      //margin-bottom: 7.5vh;
      margin-top: 8vh;
      z-index: -1;
      padding: 0 3vw;
      border-radius: 8px;
      overflow-x: hidden;

      .form {
        .schedule, .body_one, .body_two, .body_three, .body_four {
          background: #ffffff;
          padding: 5px 12px;
          margin-bottom: 10px;
          border-radius: 8px;

          .top_img {
            text-align: center;
          }

          .shop_information {
            height: 26px;
            line-height: 26px;
            font-size: 16px;
            font-weight: 900;
            padding-left: 10px;
            background: url("../assets/img_shop_text.png") no-repeat;
            background-size: 111px 26px;
            margin-bottom: 0;
          }
          .account {
            .label, .text {
              font-size: 14px;
            }
          }

          .but {
            width: 100%;
            border-bottom: 1px solid #F3F3F3;
            padding-bottom: 5px;
            margin-top: 10px;

            .shop_logo,
            .shop_name,
            .shop_introduction,
            .shop_address,
            .shop_remarks,
            .shop_purchase,
            .shop_remarks_profit,
            .shop_no_purchase,
            .shop_phone,
            .shop_contact_address,
            .shop_license,
            .contact_name,
            .contact_type,
            .contact_credit,
            .contact_license,
            .contact_domicile,
            .contact_register,
            .contact_business,
            .contact_range {
              display: flex;
              justify-content: space-between;
              margin-bottom: 0;

              /deep/.el-form-item__content {
                .shop_contact_business,
                .shop_contact_range {
                  .el-input__inner {
                    border: none;
                  }
                }
              }

              /deep/ .el-form-item__label {
                width: 45%;
                font-size: 16px;
                font-weight: 700;
              }

              /deep/ .el-form-item__label::after {
                content: '*';
                color: red;
              }

              /deep/ .el-form-item__content {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 80%;

                .image {
                  width: 35px;
                  height: 35px;
                }

                .ims {
                  margin: 0;

                  .ims_ss {
                    position: relative;
                    margin-right: 10px;

                    .el-image {
                      width: 50px;
                      height: 50px;
                      margin-right: 5px;
                    }

                    .icon_error {
                      position: absolute;
                      top: -3px;
                      right: 0;
                    }
                  }
                }

                .upload-demo {
                  .el-upload {
                    .el_button {
                      padding: 0;
                      border: 0;
                      background: none;
                    }
                  }
                }

                .shop_contact_credit {
                  .el-input__inner {
                    font-size: 12px;
                  }
                }

                .box_ss {
                  .van-field {
                    padding-right: 0;
                  }

                  .van-field::after {
                    border: 0;
                  }
                }
              }

              //输入框
              .shop,
              .contact_phone,
              .shop_contact_name,
              .shop_contact_type,
              .shop_contact_credit,
              .shop_contact_license,
              .shop_contact_domicile,
              .shop_contact_register,
              .shop_contact_business,
              .shop_contact_range {
                font-size: 14px;
                border: 0;

                /deep/ .el-input__inner {
                  border: none;
                }
              }

              //  简介
              .shop_textarea {
                border: 0;

                /deep/ .el-textarea__inner {
                  border: 0;
                }

                /deep/ .el-input__count {
                  display: none;
                }
              }

              //店铺logo上传按钮样式调整
              .uploadLogo {
                line-height: 0;

                /deep/ .el-upload-list {
                  .el-upload-list__item {
                    width: 48px;
                    height: 48px;
                  }
                }

                /deep/ .el-upload {
                  border: 0;
                  background: none;
                  width: 48px;
                  height: 48px;
                  line-height: 48px;

                  .logo_img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .uploadLogo2 {
                line-height: 0;

                /deep/ .el-upload-list {
                  .el-upload-list__item {
                    width: 48px;
                    height: 48px;
                  }
                }

                /deep/ .el-upload {
                  display: none;
                  border: 0;
                  background: none;
                  width: 48px;
                  height: 48px;
                  line-height: 48px;

                  .logo_img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .percentage {
                font-size: 12px;

                /deep/ .el-input__inner {
                  padding-right: 15px;
                }
              }
            }

            .shop_remarks,
            .purchase,
            .shop_remarks_profit,
            .no_purchase,
            .shop_license,
            .contact_name,
            .contact_type,
            .contact_credit,
            .contact_license,
            .contact_domicile,
            .contact_register,
            .contact_business,
            .contact_range {
              /deep/ .el-form-item__label::after {
                content: '';
                color: red;
              }
            }

            .shop_remarks_profit,
            .shop_no_purchase {
              /deep/ .el-form-item__label::after {
                content: '';
                display: inline-block;
                width: 13px;
                height: 13px;
                background-image: url('../assets/doubt.png');
                background-size: 100% 100%;
                margin-left: 3px;
              }
            }

            .prompt_text {
              font-size: 12px;
              font-weight: 500;
              color: #F84141;
            }

            .shop_address,
            .shop_phone,
            .shop_contact_address,
            .shop_license {
              /deep/ .el-form-item__label {
                width: 60%;
              }
            }

            .shop_address {
              /deep/ .el-form-item__label {
                width: 50%;
                padding-right: 0;
              }

              /deep/ .el-form-item__content {
                width: 86%;
                padding-left: 0;

                .box_ss {
                  width: 100%;
                  margin-left: 0;

                  .van-field {
                    padding-left: 14px;
                  }
                }
              }
            }

            .purchase,
            .no_purchase,
            .shop_remarks_profit {
              /deep/ .el-form-item__label {
                width: 70%;
              }
            }
          }

          .but_bottom {
            border-bottom: 0 solid #F3F3F3;
          }
        }
      }

      //底部
      .bottom {
        position: relative;
        margin-bottom: 5px;
        display: flex;
        height: 6vh;
        line-height: 6vh;
        text-align: center;
        padding: 0;
        width: 100%;
        background-color: #efefef;


        .bottom_button {
          width: 94vw;
          font-size: 18px;
          border: none;
          border-radius: 25px;
          font-weight: 900;
          color: #ffffff;
          background-color: #2082dd;
        }
      }
    }

    //dialog
    .dialog_dialogVisible {
      /deep/ .messageZindex {
        margin-top: 20vh;
        text-align: center;
        border-radius: 8px;

        .el-dialog__header {
          padding: 0;
        }

        .el-dialog__body {
          padding: 10px 20px;
        }

        .el-dialog__footer {
          text-align: center;
          font-size: 16px;
          color: #1ECC9A;
          border-top: 1px solid #F3F3F3;
        }
      }
    }

    // 审核入驻
    .shenhe {
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/ .el-dialog {
        border-radius: 10px;
        margin-top: 0 !important;
        box-shadow: none;
        -webkit-box-shadow: none;
        //box-shadow: 0.3px 1.3px 2.6px rgba(0, 0, 0, 0.045), 2px 10px 21px rgba(0, 0, 0, 0.09);
        //box-shadow: 0.3px 1.3px 2.6px #D8EAE5, 2px 3px 21px #D8EAE5;
        .el-dialog__header {
          display: none;
          span {
            font-weight: 900;
          }
        }

        .el-dialog__body {
          padding-bottom: 0;

          .login-form {
            text-align: center;
            .img_but {
              .logo_img {
                width: 16vw;
              }
            }
            .title_but {
              font-size: 5vw;
              font-weight: 900;
              margin-top: 3vw;
              margin-bottom: 4vw;
            }
            .item_phone {
              margin-bottom: 1.5vh;
              .el-form-item__content {
                position: relative;
                //手机号
                .phone {
                  .el-input__inner {
                    border-radius: 3vw;
                  }
                }
                .iconfont, .ips {
                  position: absolute;
                  right: 10px;
                  top: 0;
                  font-weight: 700;
                  color: #929292;
                  font-size: 6vw;
                }
                .ips {
                  top: 7px;
                  color: #000;
                }
              }
            }
            .item_yanzhengma {
              margin-bottom: 0;
              //验证码
              .yanzhengma {
                width: 100%;
                .el-input__inner {
                  border-top-left-radius: 3vw;
                  border-bottom-left-radius: 3vw;
                }
                .el-input-group__append {
                  border-top-right-radius: 3vw;
                  border-bottom-right-radius: 3vw;
                }
                /deep/ .el-form-item__content {
                  display: flex;
                }

                .input {
                  width: 50%;
                }

                .but {
                  width: 40%;
                  margin-left: 10%;

                  .button {
                    width: 100%;
                    padding: 13px 5px;
                  }

                  .button1 {
                    background-color: #1ecc9a;
                    border: 1px solid #1ecc9a;
                  }

                  .button2 {
                    background-color: #ccc;
                    border: 1px solid #ccc;
                  }
                }
                .el-input-group__append {
                  .button2 {
                    margin: 0;
                  }
                }
              }
            }
          }
        }

        //底部按钮
        .dialog-footer {
          .el-button {
            width: calc(100% - 10px);
            border-radius: 3vw;
            padding: 10px 0;
            background-color: #33be94;
            border-color: #33be94;
          }
        }
      }
    }
  }
}

</style>
<style lang="less">
.form_item_cascaderss .el-cascader-node {
  padding: 0;
}

.form_item_cascaderss .is-active {
  padding: 0 30px 0 20px;
}

.form_item_cascaderss .el-cascader-menu {
  width: 145px;
  min-width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/H5.vue